<h1 *ngIf="!noTitle" matDialogTitle>
    {{ (title ? title : 'DIALOG.CONFIRM_TITLE') | translate }}
</h1>
<div mat-dialog-content>
    <p *ngIf="confirmMessage.length" class="text-center" [innerHTML]="confirmMessage"></p>
    <p *ngIf="confirmMessageTranslation.length" class="text-center">
        {{ confirmMessageTranslation | translate }}
    </p>
    <div fxLayout="row">
        <div fxFlex="1 1 auto"></div>
        <div fxFlex="1 1 auto">
            <p *ngFor="let p of paragraph" class="text-justify">
                {{ p | translate }}
            </p>
            <table>
                <tr *ngFor='let r of rows' [style.font-size.px]='rowFontSize' [innerHTML]='r'></tr>
            </table>
            <p *ngIf="blueItalicLine.length" class="text-justify" style="color: #19A0FF; font-style: italic;">
                {{ blueItalicLine | translate }}
            </p>
        </div>
        <div fxFlex="1 1 auto"></div>
    </div>
    <mat-form-field
        style="width: 100%"
        appearance="outline"
        *ngIf="inputLabel.length"
    >
        <mat-label>{{ inputLabel | translate }}</mat-label>
        <input [(ngModel)]="input" matInput type="text" />
    </mat-form-field>
</div>
<div mat-dialog-actions class="pt-24 pb-24 center">
    <div class="button-wrapper">
        <button
            mat-raised-button
            color="accent"
            (click)="dialogRef.close(getReturnValue())"
        >
            {{ (yesLabel ? yesLabel : 'COMMON.AGREE') | translate }}
        </button>
        <button
            mat-raised-button
            color="primary"
            class="ml-16"
            (click)="dialogRef.close(false)"
            *ngIf="!noCancel"
        >
            {{ (noLabel ? noLabel : 'COMMON.QUIT') | translate }}
        </button>
    </div>
</div>
